const style = {
  marginTop0: { marginTop: '0px' },
};

export default style;
